import React from 'react';
import { useEffect, useState } from 'react';
import {GoogleMap, Marker} from "@react-google-maps/api";

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var urlObtenerCodigoPostal = "https://maps.googleapis.com/maps/api/geocode/json?"

const mapContainerStyle = {
    width: '100%',
    height: '100%',
}

export default function GoogleMapComponentLocation(props) {

  useEffect(() => {

    if( (document.getElementById("idMunicipioActual") !== null) && (document.getElementById("idMunicipioActual").value !== "")){

      //Datos previamente actualizados en General info -> configurarSinDireccion()
      var latitud = document.getElementById("latitudUbicacion").value
      var longitud = document.getElementById("longitudUbicacion").value

      props.setMarkers(() => [      
        {
          lat: parseFloat(latitud),
          lng: parseFloat(longitud)
        }
      ]);
      
      //Centro el mapa en ese marcador
      props.coordenadas[0].lat = latitud
      props.coordenadas[0].long = longitud

      props.activarBotonGuardado()

    }
  }, [props.coordenadas]);


    function setearCodigoPostalDeCoordenadasSinUbicacion(latitud, longitud){

      var urlCP = urlObtenerCodigoPostal + "latlng="+latitud+","+longitud+"+&key=AIzaSyAKzBBmfUcgXRb4q_uUmLtZDUS9aedgsX4"

      var codigoPostal = ""

      var xhttp = new XMLHttpRequest();
      xhttp.open("GET", urlCP, true);    
      xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            
            var jsonRespuestaCP = JSON.parse(this.responseText)        
                        
            console.log("Código postal recuperado correctamente. ")    

            for(var x=0; x < jsonRespuestaCP.results.length; x++){
              if(jsonRespuestaCP.results[x].types[0] === "postal_code"){
                
                codigoPostal = jsonRespuestaCP.results[x].address_components[0].long_name    
                break
              }
            }    

            document.getElementById("codigoPostalUbicacion").value = codigoPostal
    
          }
          if (this.readyState === 4 && this.status !== 200) {                
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
          }            
      };
      xhttp.send();  
    
    }	


  const onMapClick = (e) => {
    
    //Actualizo el marcador
    props.setMarkers(() => [      
      {
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      }
    ]);

    //Centro el mapa en ese marcador
    props.coordenadas[0].lat = e.latLng.lat()
    props.coordenadas[0].long = e.latLng.lng()

    //Preparo los datos de guardado
    setearCodigoPostalDeCoordenadasSinUbicacion(e.latLng.lat(), e.latLng.lng())
    document.getElementById("latitudUbicacion").value = e.latLng.lat()
    document.getElementById("longitudUbicacion").value = e.latLng.lng()

  };

    return(
      
        <GoogleMap        
        mapContainerStyle={mapContainerStyle} 
        zoom={12}         
        center={{
          lat: parseFloat(props.coordenadas[0].lat), 
          lng: parseFloat(props.coordenadas[0].long)
          }}
        onClick={onMapClick}        
        >

        {props.markers.map((marker, index) => (
            <Marker 
              key={index}
              position={{ 
                lat: marker.lat,
                lng: marker.lng 
              }} />
        ))}

        </GoogleMap>

    )
}
